import { Connector } from "../../../../../../types"

type Props = {
  info: Connector
}

const DirectionCell = ({ info }: Props) => {
  const { direction } = info

  const getDirectionIcon = () => {
    switch (direction) {
      case "incoming":
        return "←"
      case "outgoing":
        return "→"
      case "bidirectional":
        return "↔"
      default:
        return "–"
    }
  }

  const getDirectionLabel = () => {
    switch (direction) {
      case "incoming":
        return "Incoming"
      case "outgoing":
        return "Outgoing"
      case "bidirectional":
        return "Bidirectional"
      default:
        return direction
    }
  }

  const getDirectionColor = () => {
    switch (direction) {
      case "incoming":
        return "text-green-600"
      case "outgoing":
        return "text-blue-600"
      case "bidirectional":
        return "text-purple-600"
      default:
        return "text-gray-600"
    }
  }

  return (
    <td className="whitespace-nowrap px-3 py-4">
      <div className={`flex items-center ${getDirectionColor()}`}>
        <span className="text-lg mr-2">{getDirectionIcon()}</span>
        <span className="text-sm font-medium">{getDirectionLabel()}</span>
      </div>
    </td>
  )
}

export default DirectionCell
